var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.71555 4.83545C6.11848 4.83545 4 6.95393 4 9.551C4 11.8874 5.81284 14.2634 7.53758 16.1599C9.26233 18.0564 10.9824 19.4411 10.9824 19.4411C10.9876 19.4452 10.9929 19.4493 10.9983 19.4533C11.2767 19.6636 11.6261 19.8003 12.0053 19.8256C12.0448 19.8327 12.0849 19.836 12.125 19.8354C12.1647 19.8359 12.2043 19.8326 12.2434 19.8256C12.2454 19.8252 12.2474 19.8248 12.2495 19.8244C12.6268 19.7982 12.9744 19.6627 13.2517 19.4533C13.257 19.4493 13.2623 19.4452 13.2675 19.4411C13.2675 19.4411 14.9876 18.0564 16.7123 16.1599C18.4371 14.2634 20.2499 11.8874 20.2499 9.551C20.2499 6.95393 18.1314 4.83545 15.5344 4.83545C13.9006 4.83545 12.7437 5.73454 12.125 6.37109C11.5063 5.73454 10.3493 4.83545 8.71555 4.83545Z",
    fill: "#EA429D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.24adede6baec682297ab3c198d45c70e.svg";
export { ForwardRef as ReactComponent };